import React from 'react';
import { useNavigation } from '../contexts/NavigationContext.js';

function PrivacyPolicy() {
    const { isMobile } = useNavigation();
    
    return (
        <div className="container mt-5">
            <div className="text-center mb-4">
                <img 
                    src="/MUSI.ico" 
                    alt="MUSI Logo" 
                    className="img-fluid" 
                    style={{ maxHeight: isMobile ? '90px' : '120px' }} 
                />
                <h2 className="mt-3">MUSI - Politika zasebnosti</h2>
            </div>
            
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="card shadow-sm">
                        <div className="card-body p-4">
                            <h3 className="card-title">POLITIKA ZASEBNOSTI</h3>
                            <p className="text-muted mb-4">Datum zadnje posodobitve: [12. April 2025]</p>

                            <p>
                                Vaša zasebnost je za nas pomembna. Ta Politika zasebnosti opisuje, katere podatke zbiramo, kako jih uporabljamo in kako jih varujemo.
                                Z uporabo naše aplikacije (v nadaljevanju "Storitev") se strinjate s prakso zbiranja in obdelave podatkov, kot je opisana v tej Politiki.
                            </p>

                            <section className="mb-4">
                                <h4>1. ZBRANI PODATKI</h4>
                                <p>Ob registraciji in uporabi Storitve lahko zbiramo naslednje podatke:</p>
                                <ul>
                                    <li><strong>Osebni podatki</strong>, kot so ime, e-poštni naslov in geslo</li>
                                    <li><strong>Podatki o uporabi</strong>, kot so datumi prijav, IP naslov, naprava in brskalnik</li>
                                    <li><strong>Podatki o dogodkih</strong>, ki jih ustvarite (npr. lokacije, časi, seznami skladb ipd.)</li>
                                    <li><strong>Komunikacija z drugimi uporabniki</strong>, vključno z objavami in komentarji</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>2. NAMEN OBDELAVE</h4>
                                <p>Podatke obdelujemo za naslednje namene:</p>
                                <ul>
                                    <li>omogočanje in izboljševanje delovanja Storitve,</li>
                                    <li>ustvarjanje in upravljanje uporabniških računov,</li>
                                    <li>omogočanje komunikacije med uporabniki,</li>
                                    <li>zagotavljanje podpore uporabnikom,</li>
                                    <li>preprečevanje zlorab in zagotavljanje varnosti,</li>
                                    <li>obveščanje o pomembnih spremembah.</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>3. PRAVNA PODLAGA</h4>
                                <p>Vaše podatke obdelujemo na podlagi:</p>
                                <ul>
                                    <li>vaše <strong>privolitve</strong> (npr. ob registraciji),</li>
                                    <li><strong>pogodbenega razmerja</strong> (za zagotavljanje Storitve),</li>
                                    <li><strong>zakonitih interesov</strong>, kot so zagotavljanje varnosti in preprečevanje zlorab.</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>4. SHRANJEVANJE PODATKOV</h4>
                                <p>
                                    Vaše podatke hranimo le toliko časa, kolikor je potrebno za namen, za katerega so bili zbrani, oziroma dokler to zahteva zakonodaja.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>5. VAROVANJE PODATKOV</h4>
                                <p>
                                    Skrbimo za ustrezne tehnične in organizacijske ukrepe za zaščito vaših osebnih podatkov pred izgubo, zlorabo, nepooblaščenim dostopom ali razkritjem.
                                    Vaše geslo je varno šifrirano in do njega nima dostopa nihče, vključno z upravljavcem.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>6. POSREDOVANJE PODATKOV</h4>
                                <p>
                                    Vaših osebnih podatkov ne prodajamo, ne delimo in ne posredujemo tretjim osebam, razen:
                                </p>
                                <ul>
                                    <li>če to zahteva zakonodaja,</li>
                                    <li>če je to potrebno za zaščito pravic ali varnosti uporabnikov ali Storitve,</li>
                                    <li>če za obdelavo podatkov uporabimo zaupanja vrednega ponudnika storitev (npr. gostovanje).</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h4>7. PRAVICE UPORABNIKOV</h4>
                                <p>V skladu z veljavno zakonodajo imate pravico, da:</p>
                                <ul>
                                    <li>dostopate do svojih osebnih podatkov,</li>
                                    <li>zahtevate popravek netočnih podatkov,</li>
                                    <li>zahtevate izbris podatkov, kadar to ni v nasprotju z zakonskimi obveznostmi,</li>
                                    <li>ugovarjate obdelavi podatkov,</li>
                                    <li>zahtevate prenosljivost podatkov.</li>
                                </ul>
                                <p>Zahteve lahko kadarkoli pošljete na [VSTAVITE E-POŠTNI NASLOV].</p>
                            </section>

                            <section className="mb-4">
                                <h4>8. PIŠKOTKI IN SLEDENJE</h4>
                                <p>
                                    Aplikacija trenutno <strong>ne uporablja</strong> piškotkov tretjih oseb ali orodij za sledenje. Če se to spremeni, bomo posodobili to Politiko in vas obvestili.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>9. SPREMEMBE POLITIKE</h4>
                                <p>
                                    Upravljavec si pridržuje pravico do spremembe te Politike zasebnosti. Spremembe stopijo v veljavo z dnem objave v aplikaciji.
                                    Z nadaljnjo uporabo Storitve po spremembah potrjujete, da se z njimi strinjate.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>10. KONTAKT</h4>
                                <p>
                                    Za dodatne informacije ali uveljavljanje svojih pravic glede varstva podatkov nas kontaktirajte na: <br />
                                    <strong>E-pošta:</strong> [admin@musi.si]
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;